import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;

export const CENTER_STORAGE_KEY = "logisticCenterId";

const api = axios.create({
  baseURL: baseUrl,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-access-token"] = token;
  }
  const centerId = localStorage.getItem(CENTER_STORAGE_KEY);
  if (centerId) {
    config.headers["integer-logistic-center-id"] = centerId;
  }
  return config;
});

export default api;

